import { ICart } from "@features/cart/ICart";

export enum OrderAuthorizationEnum {
    OrderOk,
    TooMuchOffer,
    OrderImpossible,
    PendingCrossSell,
    PendingAcquisition,
    TooMuchOfferCrossSell,
    InCollection

}

export const getOrderAuthorization = (userCart: ICart | undefined) => {

    if (userCart && userCart.nbrAdditionalAllowedSubscriptions <= 0) {
        const numberOfOfferCanOrder = userCart.offers.length + userCart.nbrAdditionalAllowedSubscriptions;

        if (numberOfOfferCanOrder <= 0) {
            return OrderAuthorizationEnum.OrderImpossible;
        }

        return OrderAuthorizationEnum.TooMuchOffer;
    }

    return OrderAuthorizationEnum.OrderOk;


};
